<ng-content></ng-content>

<ng-container [ngSwitch]="mode">
  <button
    fxFlex="grow"
    mat-raised-button
    [color]="addressHelper?.isInvalid ? 'warn' : 'secondary'"
    (click)="openAddressModal()"
    *ngSwitchCase="'addModal'"
  >
    <mat-icon>add</mat-icon>Add Mailing Address
  </button>
  <div
    *ngSwitchCase="'editModal'"
    fxFlex="grow"
    fxLayoutAlign="space-between start"
    class="has-address"
    [class.isInvalid]="addressHelper?.isInvalid"
  >
    <read-only-address [address]="addressHelper?.address" [hideStatus]="!staffCanValidate"></read-only-address>
    <div>
      <button mat-icon-button color="primary" (click)="openAddressModal()">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button color="primary" (click)="confirmDialog.open()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
  <address-editor class="mt-1" *ngSwitchCase="'inline'" [address]="addressHelper"></address-editor>
</ng-container>

<lib-dialog
  #confirmDialog="dialog"
  (yes)="clearAddress()"
  header="Remove Mailing Address"
  yesText="Remove"
  [width]="300"
>
  <ng-template>Are you sure you want to remove the mailing address?</ng-template>
</lib-dialog>
<!--edit address modal-->
<lib-dialog
  (no)="cancelEditAddress()"
  [onOkay]="onOkay"
  #addressDialog="dialog"
  [header]="hasAddress ? 'Update Address' : 'Add Address'"
  [yesText]="(hasAddress ? 'Update ' : 'Add ') + (staffCanValidate && isStaff ? 'and Verify' : 'Address')"
  [isAffirmativeBasicColor]="staffCanValidate && isStaff"
  [form]="addressHelper?.addressFormGroup"
>
  <ng-template>
    <address-editor [address]="addressHelper"></address-editor>
  </ng-template>

  <ng-template #extraButtons let-clickClose>
    <button
      *ngIf="staffCanValidate && isStaff"
      mat-flat-button
      color="primary"
      (click)="saveWithoutValidate(clickClose)"
    >
      {{ hasAddress ? 'Update' : 'Add' }} Address
    </button>
  </ng-template>
</lib-dialog>

<!--address had error modal. correctedAddress or !correctedAddress-->
<lib-dialog
  #addressWarning="dialog"
  header="We are unable to verify your address as entered"
  yesText="Use this address provided"
  noText="Edit Address"
>
  <ng-template let-clickClose>
    <div *ngIf="correctedAddress">
      Please make a selection of the address that you provider or the recommended USPS verified address. If you'd prefer
      to edit your address, you can do so after the selection is made.
    </div>
    <div fxLayoutAlign="space-between" *ngIf="correctedAddress">
      <div fxLayout="column" fxLayoutGap="10px">
        <read-only-address [address]="addressHelper?.address" [hideStatus]="true">
          <div class="semi-bold">Use the address I provided</div>
        </read-only-address>
        <button color="primary" mat-flat-button (click)="useAddress(clickClose, null)">Use this address</button>
      </div>
      <div fxLayout="column" fxLayoutGap="10px">
        <read-only-address [address]="correctedAddress" [hideStatus]="true">
          <div class="semi-bold">Recommended address:</div>
        </read-only-address>
        <button color="primary" mat-flat-button (click)="useAddress(clickClose, correctedAddress)">
          Use Recommended Address
        </button>
      </div>
    </div>
    <div *ngIf="!correctedAddress">We were unable to verify the address due to the following issue:</div>
    <div *ngIf="!correctedAddress">
      <div class="semi-bold" fxLayout="row" fxLayoutGap="10px">
        <mat-icon color="accent">warning</mat-icon>{{ validationResult.message }}
      </div>
    </div>
  </ng-template>
</lib-dialog>
